<template>
  <div>
    <div class="my-2 text-right">
      <b-button
        data-cy="add"
        size="sm"
        variant="outline-primary"
        @click="addSubstituteModal"
      >
        Agregar
      </b-button>
    </div>
    <SubstituteTable
      @edit-substitute="editUser"
      @enable-substitute="enableSubstitue"
      @disable-substitute="disableSubstitue"
      @store-substitute="storeSubstitue"
    />
    <b-modal
      size="lg"
      ref="substitute-modal"
      hide-footer
      no-close-on-backdrop
      title="Suplencia"
    >
      <form data-vv-scope="data-user">
        <div class="row mb-5">
          <div class="col-12 mt-3">
            <list-user
              class="w-100"
              name="user"
              label="Usuarios"
              v-model="process.user"
              :danger="errors.has('data-user.user')"
              :danger-text="errors.first('data-user.user')"
              v-validate="'required'"
            />
          </div>
          <div class="col-6 mt-3">
            <label>Fecha inicio suplencia</label>
            <datepicker
              data-cy="start-date"
              class="w-100"
              name="issueDate"
              :language="es"
              v-model="process.start"
            />
          </div>
          <div class="col-6 mt-3">
            <label>Fecha fin suplencia</label>
            <datepicker
              data-cy="final-date"
              class="w-100"
              name="issueDate"
              :language="es"
              v-model="process.end"
            />
          </div>
        </div>
        <div v-if="error.message !== ''" class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to text-right"
             style="height: 32px;">
          <span class="span-text-validation">
            {{error.message}}
          </span>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <b-button
            data-cy="next-button"
            variant="outline-primary"
            @click="saveChanges"
          >
            Guardar
          </b-button>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>

import Vue from 'vue';
import Datepicker from 'vuejs-datepicker';
import { es } from 'vuejs-datepicker/dist/locale';
import { mapActions, mapGetters } from 'vuex';

import ListUser from '@/febos/chile/lists/components/ListUser';
import SubstituteTable from '@/febos/global/management/vistas/components/SubstituteTable';

export default {
  mixins: [],
  components: {
    Datepicker,
    ListUser,
    SubstituteTable
  },
  data() {
    return {
      es,
      error: {
        message: ''
      },
      process: {
        user: ''
      }
    };
  },
  watch: {
    process(newValue) {
      this.process = newValue;
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'substitutes'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ])
  },
  methods: {
    ...mapActions('Empresas', [
      'updateUserComppany',
      'createUserCompany',
      'addSubstituteUser',
      'getSubstituteUser'
    ]),
    addSubstituteModal() {
      this.process = {};
      this.$refs['substitute-modal'].show();
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async enableSubstitue(user) {
      const substitute = {
        ...user,
        estado: 1
      };
      const hasActiveSubstitute = this.substitutes
        .some((userSubstitute) => userSubstitute.estado.toString() === '1'
          && userSubstitute.usuarioRemplazaId !== user.usuarioRemplazaId);
      if (hasActiveSubstitute) {
        this.$bvToast.toast(
          'Ya tienes un suplente configurado',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }
      await this.addSubstituteUser({ empresaId: this.company.id, substitute });
      this.listSustitutes(true);
    },
    async disableSubstitue(user) {
      const substitute = {
        ...user,
        estado: 5
      };
      await this.addSubstituteUser({ empresaId: this.company.id, substitute });
      this.listSustitutes(true);
    },
    storeSubstitue(user) {
      const substitute = {
        ...user,
        estado: 100
      };
      this.addSubstituteUser({ empresaId: this.company.id, substitute });
    },
    editUser(user) {
      this.process = {
        user: user.usuarioRemplazaId,
        start: user.remplazoInicio,
        end: user.remplazoFin,
        id: user.remplazoId,
        estado: user.estado
      };
      this.$refs['substitute-modal'].show();
    },
    async listSustitutes(preserve = false, intent = 0) {
      const data = await this.getSubstituteUser({
        empresaId: this.company.id,
        filtros: `usuarioId:${this.currentUser.id}`,
        preserve
      });
      const maxWait = 30;
      const estadosPendientes = [1000, 2, 6];
      const pendiente = data.usuarios.some((usuario) => estadosPendientes.includes(usuario.estado));
      if (intent < maxWait && pendiente) {
        setTimeout(() => {
          this.listSustitutes(preserve, intent + 1);
        }, 1000);
      }
    },
    async saveChanges() {
      const isValid = await this.validateForm('data-user');
      if (!isValid) {
        return;
      }
      if (!this.process.start) {
        this.error.message = 'No has agregado la fecha de inicio';
        return;
      }
      if (!this.process.end) {
        this.error.message = 'No has agregado la fecha de término';
        return;
      }

      this.error.message = '';

      const isUser = this.process.user === this.currentUser.id;

      if (isUser) {
        this.$bvToast.toast(
          'No puedes seleccionarte como suplente',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }
      const substitute = {
        empresaId: this.company.id,
        usuarioId: this.currentUser.id,
        usuarioRemplazaId: this.process.user,
        estado: this.process.estado,
        remplazoInicio: Vue.moment(this.process.start).format('YYYY-MM-DD'),
        remplazoFin: Vue.moment(this.process.end).format('YYYY-MM-DD'),
      };

      if (this.process.id) {
        substitute.remplazoId = this.process.id;
      }

      await this.addSubstituteUser({ empresaId: this.company.id, substitute });
      this.listSustitutes();
      await this.$refs['substitute-modal'].hide();
    },
    cancelEdit() {}
  }
};
</script>
<style scoped>
.chip-custom {
  font-size: 12px;
  margin-top: 10px;
  color: #ffb300;
  background: #fff5df;
  border-radius: 10px;
  padding: 4px 8px;
}
</style>
